(function() {
	'use strict';
	try {
		var boxes = document.querySelectorAll('.compare-box');// parents of the toggler/selector in which data are being switched

		boxes.forEach(function(box) {
			var
				toggler = box.querySelector('.toggler'),
				selector = box.querySelector('.form-select');

			// detect selected value from TOGGLER
			if(toggler) {
				var items = toggler.querySelectorAll('.toggler-item');

				items.forEach(function(item) {
					// lookup for selected option and set up content by this item (for cases where .hide classes are not properly added in the DOM)
					if (item.classList.contains('selected')) {
						showContent(item.dataset.option, box);
					}

					// add listener to monitor changes in toggler
					item.addEventListener('click', function(){
						switchToggler(item, items);
						showContent(item.dataset.option, box);
					});
				});



			// detect selected value from SELECTOR
			} else if(selector) {
				var items = selector.querySelectorAll('option');

				items.forEach(function(item) {
					// lookup for selected option and set up content by this item (for cases where .hide classes are not properly added in the DOM)
					if (item.selected) {
						showContent(item.value, box);
					}
				});

				// add listener to monitor changes in Selector
				selector.addEventListener('change', function(){
					showContent(this.value, box);
				});
			}
		});


		// Switch items in toggler and show content
		function switchToggler(chosenItem, items) {
			items.forEach(function(item) {
				item == chosenItem ? item.classList.add('selected') : item.classList.remove('selected');
			});
		};


		// Make selected option content visible
		function showContent(selectedOption, box) {
			// add .hide to all elements with .js-optionN except chosen option
			box.querySelectorAll("[class*='js-option']").forEach(function(el) {
				el.classList.contains('js-option' + selectedOption) ? el.classList.remove('hide') : el.classList.add('hide');
			});
		};
		


	} catch (error) {
		// singe data layer error tracking
		if (typeof sdl !== 'undefined') {
			console.error(error);
			sdl.push({
				system: {
					error: {
						type: error.name,
						message: error.message,
					}
				},
				event: 'system.error'
			});
		}
	}
})();
